export default "__VITE_ASSET__B7K93AGd__"